import React from 'react';
import { Redirect } from 'react-router-dom';
import RoleForm from './role_form';
import update from 'immutability-helper';
import { Message } from '../Message';
import { PageTitle } from '../PageTitle';
import { RolesService, RoutesService, GroupingsService } from '../../services';
import { connect } from 'react-redux';
import i18next from 'i18next';

@connect(state => {
  return {
    currentGrouping: state.currentGrouping.currentGrouping
  }
})
class RoleEdit extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      roleId: props.match.params.roleId,
      role: null,
      operationsNotAssigned: null,
      showDeleteRoleModal: false,
      deleted: false,
      localErrorMessage: null,
      localSuccessMessage: null,
      routes: null,
      allAvailableRoutes: null,
      adhocRoutes: null,
      templates: null
    };
  }

  componentDidMount() {
    RolesService.get(this.state.roleId).then(response => {
      this.setState({
        role: response.role,
        adhocRoutes: response.role.uiRoutes,
        templates: response.role.actionRoleTemplates
      });
    }).catch(error => {
      console.error(error);
      this.setState({
        localErrorMessage: error.message
      });
    });

    GroupingsService.listAll().then(response => {
      this.setState({
        deviceGroupings: response.groupings
      });
    }).catch(error => {
      console.error(error);
      this.setState({
        localErrorMessage: error.message
      });
    });

    GroupingsService.getAllWithAccess(this.props.currentGrouping.id).then(response => {
      this.setState({
        groupingFilterOptions: response.groupings
      });
    }).catch(error => {
      console.error(error);
      this.setState({
        localErrorMessage: error.message
      });
    });

    RoutesService.listAll().then(response => {
      this.setState({
        allAvailableRoutes: response.routes.filter(uiRoute => uiRoute.parentTitle !== null)
      });
    }).catch((error) => {
      console.error(error);
      this.setState({
        localErrorMessage: error.message
      });
    });
  }

  handleLocalError(localErrorMessage) {
    this.setState({ localErrorMessage: localErrorMessage });
  }

  handleLocalSuccess(localSuccessMessage) {
    this.setState({ localSuccessMessage: localSuccessMessage });
  }

  messageDismissCallback() {
    this.setState({
      localErrorMessage: null,
      localSuccessMessage: null
    });
  }

  deleteRole() {
    RolesService.remove(this.state.role).then(response => {
      this.setState({ deleted: true });
    }).catch(error => {
      console.error(error);
      this.setState({errorMessage: i18next.t('messages.error-deleting-role')})
    });
  }

  findGrouping(id) {
    for (let i = 0; i < this.state.deviceGroupings.length; i++) {
      if (this.state.deviceGroupings[i].id == id)
        return this.state.deviceGroupings[i]
    }
    return null
  }

  getGroupingMatchValue(newValue) {
    let curGrouping = this.findGrouping(newValue.value)
    let value = ''
    if (curGrouping.fullyQualifiedName.includes('.')) {
      if (curGrouping.deviceGroup.children.length > 0)
        value = curGrouping.fullyQualifiedName + "%"
      else
        value = curGrouping.fullyQualifiedName
    } else {
      value = '%'
    }
    return value
  }

  onRoutesChanged(adhocRoutes) {
    this.setState({ adhocRoutes: adhocRoutes });
  }

  onTemplatesChanged(templates) {
    this.setState({ templates: templates });
  }

  handleSubmit({ name, description, deviceGroupingMatch, deviceGroup }) {

    const updatedRoles = this.state.adhocRoutes.map(uiRoute => {
      return { id: uiRoute.id };
    });

    const updatedTemplates = this.state.templates.map(template => ({id: template.id}));

    this.state.role = this.refs.routesList ? this.refs.routesList.state.role : this.state.role
    let groupId = deviceGroup ? {id: deviceGroup.deviceGroup.id} : null
    const localRole = update(this.state.role, {
      name: { $set: name },
      description: { $set: description },
      deviceGroupingMatch: { $set: deviceGroupingMatch ? this.getGroupingMatchValue(deviceGroupingMatch) : null },
      deviceGroup: {$set: groupId},
      uiRoutes: { $set: updatedRoles },
      actionRoleTemplates: { $set: updatedTemplates}
    });

    RolesService.update(localRole).then(response => {
      this.setState({
        role: response.role,
        localSuccessMessage: i18next.t('messages.role-updated')
      });
    }).catch(error => {
      this.setState({
        localErrorMessage: i18next.t('messages.error-updating-role')
      });
      console.error(error);
    });

  }

  render() {
    if (this.state.deleted) {
      return ( <Redirect to={{ pathname: '/admin/roles', roleType: this.state.role.roleType, state: { from: this.props.location, successMessage: i18next.t('messages.role-deleted') } }}/> );
    }

    if (this.state.errorMessage) {
      return (
          <Redirect to={{
            pathname: '/admin/roles',
            state: {
              errorMessage: this.state.errorMessage
            }
          }}/>
      );
    }

    if (this.state.role && this.state.deviceGroupings && this.state.groupingFilterOptions &&
        ((this.state.role.roleType && this.state.role.roleType.token === 'action_role' && this.state.allAvailableRoutes) ||
         (this.state.role.roleType && this.state.role.roleType.token !== 'action_role'))) {
      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
      return (
          <div>
            <div className="row">
              <PageTitle title={`${i18next.t(`role-types.${this.state.role.roleType.token}`)} : ${this.state.role.name}`}
                         backLinkWithParams= {{
                           link: {
                             pathname: "/admin/roles",
                             search: backLinkSearch,
                             roleType: this.state.role.roleType
                           }
                         }} />
            </div>

            <Message
                messages={{ state: { successMessage: this.state.localSuccessMessage } }}
                errorMessage={this.state.localErrorMessage}
                messageDismissCallback={this.messageDismissCallback.bind(this)}
            />

            <RoleForm
                groupingFilterOptions={this.state.groupingFilterOptions}
                allAvailableRoutes={this.state.allAvailableRoutes}
                role={this.state.role}
                onRoutesChanged={this.onRoutesChanged.bind(this)}
                onTemplatesChanged={this.onTemplatesChanged.bind(this)}
                onSubmit={this.handleSubmit.bind(this)}
                errorMessage={this.props.errorMessage}
                onDelete={this.deleteRole.bind(this)}
                roleType={this.state.role.roleType}
                backLinkWithParams= {{
                  link: {
                    pathname: "/admin/roles",
                    search: backLinkSearch,
                    roleType: this.state.role.roleType
                  }
                }}
            />
          </div>
      );
    } else {
      return (
          <div className="loader">{i18next.t('loading')}</div>
      );
    }
  }
}

export default RoleEdit;
